<div class="container-fluid py-3 sme-help-page">
  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <h4 class="mb-0">SME help — create a lesson</h4>
    <span class="text-muted small">Loaded from <code>docs/sme-new-lesson-guide.md</code></span>
  </div>

  <div *ngIf="loading" class="text-muted">Loading guide…</div>

  <div *ngIf="error" class="alert alert-warning">{{ error }}</div>

  <article *ngIf="html && !loading" class="sme-help-article card shadow-sm">
    <div class="card-body md-body" [innerHTML]="html"></div>
  </article>
</div>
